"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
};
var unescapeMap = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#x27;': "'",
    '&#x60;': '`'
};
function escapeHtml(value) {
    return value.replace(/["'<>`&]/g, function (part) {
        return escapeMap[part];
    });
}
exports.escapeHtml = escapeHtml;
function unescapeHtml(value) {
    return value.replace(/&(?:quot|#x27|lt|gt|#x60|amp);/g, function (part) {
        return unescapeMap[part];
    });
}
exports.unescapeHtml = unescapeHtml;
